if (typeof customElements.get("product-story") === 'undefined') {

    class ProductStory extends HTMLElement {
        constructor() {
            super();
            this.container = this.querySelector(".product-story-container");
            this.textContentContainer = this.querySelector(".product-story-text-content");
            window.addEventListener("resize", function(textContainer) {
                if (!window.matchMedia("min-width: 768px").matches) {
                    let containerHeight = (textContainer.offsetHeight * 0.45) * -1;
                    textContainer.style.marginBottom = containerHeight + "px";
                }
            }.bind(window, this.textContentContainer));
        }

        connectedCallback() {
                this.adjustHeight(this.textContentContainer);   
        }

        adjustHeight(textContainer) {
            if (!window.matchMedia("min-width: 768px").matches) {
                let containerHeight = (textContainer.offsetHeight * 0.45) * -1;
                textContainer.style.marginBottom = containerHeight + "px";
            }
        }

    }

    customElements.define('product-story', ProductStory);
}